export default __webpack_public_path__ + "static/media/FitnessApp.54587ff1.webp";